import { render, staticRenderFns } from "./read-instructions.vue?vue&type=template&id=c67768b8&scoped=true"
import script from "./read-instructions.vue?vue&type=script&lang=js"
export * from "./read-instructions.vue?vue&type=script&lang=js"
import style0 from "./read-instructions.vue?vue&type=style&index=0&id=c67768b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67768b8",
  null
  
)

export default component.exports